import mapResponseToTaxes from './mappers/mapResponseToTaxes'

export default function fetchTaxes(api: GlobalFetch) {
  return async function() {
    const buildUrl = `/api/v2/invoice/rates`
    const response = await api.fetch(buildUrl)
    const responseBody: IData = await response.json()

    return mapResponseToTaxes(responseBody)
  }
}

export interface IData {
  messages: string[]
  items: IItemData[]
}

interface IItemData {
  id: string
  id_object: string
  rate: number
  deleted: string
  created_at: string
  updated_at: string
}
